export default __webpack_public_path__ + "static/media/Aviso-orange.7e6ec870.svg";